// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2324372b","198":"73060da2","498":"5cf895aa","703":"87007ba5","817":"40195433"}[chunkId] + ".chunk.js";
};